import { Link, useLocation } from "react-router-dom";
import styles from "./SideBar.module.scss";
import classNames from "classnames";
import { useState } from "react";
import { isMobile, MobileView } from "react-device-detect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

export default function SideBar() {
  const location = useLocation();
  const [isMobileNavVisible, setIsMobileNavVisible] = useState<boolean>(false);

  function toggleHamburger() {
    setIsMobileNavVisible((isMobileNavVisible) => !isMobileNavVisible);
  }

  function HamburgerMenu() {
    return (
      <FontAwesomeIcon
        className={styles.hamburgerMenu}
        onClick={() => toggleHamburger()}
        icon={faBars}
      />
    );
  }

  return (
    <>
      {isMobile && !isMobileNavVisible ? (
        <HamburgerMenu />
      ) : (
        <div className={styles.container}>
          <MobileView>
            <FontAwesomeIcon
              className={styles.hamburgerMenu}
              onClick={() =>toggleHamburger()
              }
              icon={faXmark}
            />
          </MobileView>
          <Link onClick={() =>toggleHamburger()}
            style={{ animationDelay: "0s" }}
            className={classNames({
              [styles.menuItem]: true,
              [styles.menuItemActive]: location.pathname.includes("/dashboard"),
            })}
            to={"dashboard"}
          >
            Översikt
          </Link>
          <Link onClick={() =>toggleHamburger()}
            style={{ animationDelay: "0.05s" }}
            className={classNames({
              [styles.menuItem]: true,
              [styles.menuItemActive]: "/invoices" === location.pathname,
            })}
            to={"invoices"}
          >
            Betalningar
          </Link>
          <Link
            onClick={() => toggleHamburger()}
            style={{ animationDelay: "0.1s" }}
            className={classNames({
              [styles.menuItem]: true,
              [styles.menuItemActive]: "/account" === location.pathname,
            })}
            to={"account"}
          >
            Mitt konto
          </Link>
        </div>
      )}
    </>
  );
}
